import {
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
  styled,
} from "@mui/material";

const StyledIconButton = styled(MuiIconButton)(() => {
  return {};
});

interface ButtonProps extends MuiIconButtonProps {
  children: React.ReactNode;
}

export const SimpleIconButton: React.FC<ButtonProps> = ({ children, ...props }) => {
  return <StyledIconButton {...props}>{children}</StyledIconButton>;
};

export default SimpleIconButton;
